<template>
<div>
  <div class="body">

    <v-alert v-if="alertType" :type="alertType" :value="true" outlined>
      <span v-html="message"></span>
    </v-alert>

    <header>
      <!-- <h1>INAIL - Istituto Nazionale per l'Assicurazione contro gli Infortuni sul Lavoro</h1> -->
      <!-- <a id="logo-inail" href="https://bandoisi.inailcloud.it/html/dummy.html#" title="torna alla homepage INAIL"> -->

      <div class="d-flex justify-space-between">
        <a id="logo-inail" href="#">
          <img src="https://app.simulatoreclickday.it/img/LogoInail.png">
        </a>
      </div>
      
    </header>

    <div class="main">
      <div style="padding-left:5px" class="simulazione-step-2">


        <template>

          <h2>Finalizza la domanda presentata</h2>

          <div class="form-gray">
            <div style="margin-bottom:40px; font-size:16px; font-weight:600;">INSERIMENTO DATI</div>
            <!-- <form method="post" action="/risultato" @submit="eseguiSimulazione" autocomplete="off"> -->
            <v-form ref="formEseguiSimulazione">
              <input type="hidden" name="_token" :value="csrf">
              <!-- <input type="hidden" name="simulazione_id" :value="simulazione.id">
              <input type="hidden" name="bando_id" :value="bandoId">
              <input type="hidden" name="anno_mese_giorno_simulazione" :value="annoMeseGiornoSimulazione"> -->

              <fieldset id="form-fieldset">

                <div style="margin-bottom:10px">Per procedere con l'invio della domanda è necessario compilare i seguenti campi:</div>

                <div style="display:inline-block;" class="simulazione-step-3 simulazione-step-5">

                  <div :id="sim.id" v-for="(sim, index) in datiSimulazione.simulazione" :key="sim.id" :class="`${sim.rispostaNonCorretta ? 'errore ' : ''}form-elem xs-12 md-6`">

                    <!-- <input v-if="sim.tipo == 'checkbox'" type="checkbox" v-model="risposteUtente[sim.id]" :value="sim.risposte[0]" :name="`risposte[${index}]`" class="form-control"> -->

                    <!-- <label>* {{ sim.domanda }}</label> -->
                    <label v-if="sim.tipo != 'checkbox' && sim.tipo != 'codice' && sim.show" style="width:100%;">* {{ sim.domanda }}</label>

                    <input v-if="sim.tipo == 'text' && sim.show" type="text" v-model="sim.risposte[0]" :name="`risposte[${index}]`" class="form-control" autocomplete="off">

                    <select v-else-if="sim.tipo == 'select' && sim.show" v-model="sim.risposte[0]" :name="`risposte[${index}]`" style="-webkit-appearance: menulist; -moz-appearance: menulist; appearance: menulist;">
                      <option value="" disabled selected hidden>Scegli una risposta</option>
                      <option v-for="(risposta, i) in sim.risposte" :key="i" :value="risposta">{{risposta}}</option>
                    </select>

                    <v-radio-group v-else-if="sim.tipo == 'radio' && sim.show" class="_radio_group mt-2" v-model="sim.risposte[0]" :error="sim.rispostaNonCorretta">
                      <v-radio
                        v-for="(risposta, index) in sim.risposte"
                        :key="index"
                        :label="risposta"
                        :value="risposta"
                        :color="scdColor"
                      ></v-radio>
                    </v-radio-group>

                    <input v-else-if="sim.tipo == 'data' && sim.show" type="text" v-model="sim.risposte[0]" :name="`risposte[${index}]`" class="form-control" autocomplete="off" style="width:200px;">

                    <div v-else-if="sim.tipo == 'codice' && sim.show">
                      <div> {{ sim.titolo }} </div>
                      <div><b> {{ sim.codice }} </b></div>
                    </div>

                    <!-- <v-checkbox
                      v-else-if="sim.tipo == 'checkbox' && sim.show"
                      class="_checkbox"
                      v-model="sim.risposte[0]"
                      :label="`* ${sim.domanda}`"
                      :error="sim.rispostaNonCorretta"
                    ></v-checkbox> -->

                    <div v-else-if="sim.tipo == 'checkbox' && sim.show">
                      <input type="checkbox" v-model="sim.risposte[0]">
                      <label for="scales">* {{ sim.domanda}}</label>
                    </div>
                    

                  </div>

                  <div style="margin-top:40px;">* Campo obbligatorio</div>

                </div>
                
                <!-- <div :class="isNomeAziendaFintoErrato ? 'errore form-elem xs-12 md-6' : 'form-elem xs-12 md-6'">
                  <label for="nomeAzienda">* {{ isNomeAziendaFintoErrato ? 'Nome azienda errato' : 'Nome azienda'}}</label>
                  <input type="text" v-model="risposteUtente.nomeAziendaFinto" name="nomeAziendaFinto" id="nomeAzienda" class="form-control" title="nomeAziendaFinto" autocomplete="off">
                </div> -->

              </fieldset>
              <div class="btn-row">
                <input v-if="tastoIndietroVisibile" @click="toggleDomande(tourInEsecuzione)" type="button" value="Indietro" title="Indietro" class="btn pull-left simulazione-step-7">

                <input type="button" v-show="tastoContinuaVisibile" @click="eseguiSimulazione(false)" value="Continua" class="btn pull-right mr-15 simulazione-step-4">
                <input type="button" v-show="tastoInviaVisibile" @click="eseguiSimulazione(true)" :disabled="eseguitaSimulazioneConGuida" value="Invia" class="btn pull-right mr-15 simulazione-step-6">

              </div>
            </v-form>
            <!-- </form> -->
          </div>
          <!-- <div>* Campo obbligatorio</div> -->

          <div v-if="eseguitaSimulazioneConGuida" class="page-overlay"></div>

          <!-- <v-row v-if="eseguitaSimulazioneConGuida" class="avviso-finale-prova"> -->
          <v-dialog persistent v-model="eseguitaSimulazioneConGuida" max-width="504px">
              <v-col class="pa-4 white--text" style="background-color:#002e5f">
                  <span class="title">
                    Complimenti, hai completato la guida! 
                  </span>
                    <br><br>
                  <span class="title">
                    Adesso clicca su OK per tornare alla Pagina Iniziale ed eseguire la tua prima vera simulazione!
                  </span>
                  <div class="ok-button-wrapper">
                    <a class="ok-button" href="/home">OK</a>
                  </div>
              </v-col>
          </v-dialog>

          
        </template>
          
        </div>
    </div>

    <footer>
      <div sm="11" style="text-align: right;">
        <span class="hidden-sm-and-down">
          Hai ancora dubbi sul funzionamento? Mostra di nuovo la <a @click="openGuide()" class="error--text"><b>GUIDA</b></a> oppure leggi le <a target="_blank" href="https://simulatoreclickday.it/#faq" class="error--text"><b>F.A.Q.</b></a>
        </span>
        <span class="hidden-md-and-up">
          <a @click="openGuide()" class="error--text"><b>GUIDA</b></a>
        </span>
      </div>
    </footer>

    <v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            style="max-width: 600px"
            :highlight="tour.highlight"
          >
          </v-step>
        </transition>
      </template>
    </v-tour>

  </div>
</div>
</template>

<script>
import mixin from '../../mixins';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      alertType: null,
      message: null,
      
      valid: false,

      isLeftingSimulazione: false,

      status: null,

      datiSimulazione: {
        id: null,
        dataOra: null,
        simulazione: [],
        // startIndex: 0,
        endIndex: null,
        simulazioneGuidata: false
      },
      bandoId: null,
      risposteUtente: {
        // Le informazioni inserite dall'utente
        // Verranno identificate attraverso un uuid generato nella funzione getDatiSimulazione()

        // uuid (stringa) : risposta dell'utente (stringa)
        // "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta
      },

      tastoContinuaVisibile: true,
      tastoIndietroVisibile: false,
      tastoInviaVisibile: false,

      // Inserisco il Csrf Token presente nei META
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

      // Tour guidato al primo accesso:
      eseguitaSimulazioneConGuida: false,

      tourSteps: [],
      tourOptions: {
          useKeyboardNavigation: false,
          labels: {
              buttonSkip: 'Salta guida',
              buttonPrevious: 'Precedente',
              buttonNext: 'Successivo',
              buttonStop: 'Fine'
          },
          highlight: true
      },
      tourCallbacks: {
        onPreviousStep: this.vaiAllaPaginaPrecedente,
        onNextStep: this.vaiAllaPaginaSuccessiva,
        onStop: this.utentePuoInteragire
      },
      currentStep: 2,
      tourInEsecuzione: false,

      ripetiGuida: false,

      // checkboxValue: false,
      // isCheckboxErrata: false,

    };
  },

  created() {
    // this.getDatiSimulazione();
  },

  mounted() {
    this.datiSimulazione.simulazione = [
          {
            show: true,
            tipo: 'select',
            domanda: 'Seleziona il tipo di bando a cui desideri partecipare:',
            risposte: [
              'Bando ISI Agricoltura 2019/2020'
            ]
          },
          {
            show: true,
            tipo: 'codice',
            titolo: 'Codice identificativo assegnato:',
            codice: '+2o8vyz0xmjtrg8r6e5meknd3zo9r65atogn8pwimxaoh5jkr71ynz6f2w3gi5mht'
          },
          {
            show: true,
            tipo: 'text',
            domanda: 'Ultimi sei caratteri del codice identificativo assegnato:',
            risposte: [
              'Bando ISI Agricoltura 2019/2020'
            ]
          },
          {
            show: true,
            tipo: 'data',
            domanda: 'Data odierna [GG/MM/AAAA]',
            risposte: [
              '28/01/2021'
            ]
          },
          {
            show: true,
            tipo: 'select',
            domanda: 'Selezionare la data Momento 3 (25/01/2021) indicata nelle regole tecniche:',
            risposte: [
              'Momento 3: 25/01/2021'
            ]
          },
          {
            show: true,
            tipo: 'checkbox',
            domanda: 'Dichiarazione di presa visione delle regole tecniche.',
            risposte: [
              true
            ]
          },
          {
            show: true,
            tipo: 'checkbox',
            domanda: 'Non sono un robot',
            risposte: [
              true
            ]
          },
        ];
    // this.getDatiSimulazione();
    // this.startSimulazioneTour();
  },

  methods: {
    getDatiSimulazione() {
      axios
      .get('/ottieniSimulazione')
      .then(response => {
        this.datiSimulazione.id = response.data.simulazione.id;
        this.datiSimulazione.dataOra = response.data.simulazione.dataOra;
        this.datiSimulazione.simulazioneGuidata = response.data.simulazione.simulazioneGuidata;
        

        this.datiSimulazione.simulazione.forEach(domanda => {
          domanda.id = this.$uuid.v4(); // assegno un id univoco ad ogni domanda
          this.risposteUtente[domanda.id] = null; // nell'oggetto delle risposte da inviare per il controllo, per ogni domanda creo una chiave univoca con lo stesso nome dell'id creato nella riga precedente

          domanda.rispostaNonCorretta = false;
          domanda.show = false;

          this.datiSimulazione.endIndex = response.data.simulazione.domandePrimaSchermata;

          for (let i = 0; i < this.datiSimulazione.endIndex; i++) {
            this.datiSimulazione.simulazione[i].show = true;
          }
        });

        this.status = response.data.status;
        this.bandoId = response.data.bandoId;

        this.startSimulazioneTour();
      })
    },
    goBack: function(){
      // Torna semplicemente indietro: disponibile quando sto visualizzando la guida
      window.location.href = "/home#/";
    },
    abbandona: function() {
      // Avviso il server di segnare la simulazione come abbandonata, e poi torno indietro
      this.isLeftingSimulazione = true;

      axios
        .get(`/simulazioni/${this.datiSimulazione.id}/${this.bandoId}/${this.annoMeseGiornoSimulazione}/abbandona`)
        .then(response => {
          window.location.href = "/home#/";
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLeftingSimulazione = false;
        });
    },
    eseguiSimulazione: function(inviaForm) {
      if (this.tourInEsecuzione) {
        return;
      }
      
      let errorFound = false;

      let risposteCorrette = {};
      
      // creo un oggetto con le risposte corrette
      // uuid (stringa) : risposta (number)
      for (const key in this.datiSimulazione.simulazione) {
        let UUIDSimulazione = this.datiSimulazione.simulazione[key].id;

        risposteCorrette[UUIDSimulazione] = this.datiSimulazione.simulazione[key].risposte[0];

        if (this.datiSimulazione.simulazione[key].tipo == 'data' && moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD", true).isValid()) {
          this.risposteUtente[UUIDSimulazione] = moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD").format('DD/MM/YYYY');
        }
      }

      // confronto le risposte dell'utente e le risposte corrette
      var indexSimulazione = 0;
      for (const uuid in this.risposteUtente) {
        const rispostaUtente = this.risposteUtente[uuid];

        // se la risposta dell'utente e quella corretta non combaciano e la domanda è renderizzata, c'è un errore
        if(rispostaUtente != risposteCorrette[uuid] && this.datiSimulazione.simulazione[indexSimulazione].show == true) {
          errorFound = true;
          this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = true;
          this.$forceUpdate();

        } else {
          this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = false;
          this.$forceUpdate();
        }
        indexSimulazione++;
      }

      if (!inviaForm && !errorFound) {
        this.toggleDomande();
        return;
      }

      if(!errorFound){
        // Se sono in modalità GUIDA, non proseguire a mostrare il risultato!
        if(this.isSimulazioneGuidata && inviaForm){
          this.eseguitaSimulazioneConGuida = true;
          this.$tours['explanatoryTour'].stop();
          return;
          // e.preventDefault();
          // return false;
        }
        // return true;

        let formData = new FormData();
        formData.append('risposte', JSON.stringify(this.risposteUtente));
        formData.append('simulazione_id', this.datiSimulazione.id);
        formData.append('bando_id', this.bandoId);
        formData.append('anno_mese_giorno_simulazione', this.annoMeseGiornoSimulazione);
        axios
        .post('/risultato',
          formData,       
          {
            headers: {
                'Content-Type': 'application/json'
            },
          }
        )
        .then(response => {
          let risultatoSimulazione = {
              bandoId: this.bandoId,
              provaGratuita: response.data.provaGratuita,
              countAltriUtenti: response.data.countAltriUtenti,
              minimoAltriUtenti: response.data.minimoAltriUtenti,
              tempoImpiegato: response.data.tempoImpiegato,
              colore: response.data.colore,
              hasError: response.data.hasError,
              message: response.data.message,
            } 

          localStorage.setItem('risultatoSimulazione', JSON.stringify(risultatoSimulazione));

          this.$router.push({ 
            name: 'risultato-route', 
            params: risultatoSimulazione
          });
        })
      }
      // else e.preventDefault();
        
    },
    toggleDomande(saltaCodice) {
      if (saltaCodice) {
        return;
      }

      for (const key in this.datiSimulazione.simulazione) {
        this.datiSimulazione.simulazione[key].show = !this.datiSimulazione.simulazione[key].show;
      }

      this.tastoContinuaVisibile = !this.tastoContinuaVisibile;
      this.tastoIndietroVisibile = !this.tastoIndietroVisibile;
      this.tastoInviaVisibile = !this.tastoInviaVisibile;
    },
    getTimeByDatetime: function(datetime) {
      return datetime.split(" ")[1];
    },
    openGuide() {
      this.ripetiGuida = true;
      if (this.tastoInviaVisibile) { // se il tasto invia è visibile vuol dire che sono nella seconda schermata e lo riporto nella prima
        this.toggleDomande();
      }
      this.startSimulazioneTour();
      // this.$tours['explanatoryTour'].start();
    },
    startSimulazioneTour() {
      // Se il parametro "Guida" è nell'URL allora avvio la guida
      if(this.isSimulazioneGuidata || this.ripetiGuida){
        this.tourInEsecuzione = true;
        
        if(this.status == 'not_started'){
          this.tourSteps = [
            {
              target: '.simulazione-step-1',
              content: `Eccoci alla tua prima Simulazione!<br>Appena si avvicina l'orario indicato, aggiorna la pagina<br>(per farlo velocemente premi 'F5' su Windows o 'Mela+R' su MAC)`
            }
          ];
        } else { // Se la simulazione è partita e la Guida è richiesta mostro questo:
          this.tourSteps = [
              {
                target: '.simulazione-step-2',
                content: `La simulazione è divisa in più pagine, ogni pagina ti chiederà di compilare dei campi`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-3',
                content: `Questa è la prima serie di campi,<br>presta molta attenzione a cosa c'è scritto.`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-4',
                content: `Questo bottone ti permette di visualizzare la seconda pagina, 
                ma solamente se avrai compilato correttamente i campi in questa pagina.`,
                params: {
                  placement: 'left-end'
                }
              },
              {
                target: '.simulazione-step-5',
                content: `Ora siamo nella seconda pagina e questa è la seconda serie di campi`,
                params: {
                  placement: 'top'
                },
                // before: promise => new Promise((resolve, reject) => {
                //   // Time-consuming UI/async operation here
                //   let response = this.eseguiSimulazione(false, true);
                //   if (response == 'pagina successiva') {
                //     resolve(response);
                //   }
                // })
                // .then(() => {
                //   this.toggleDomande();
                //   console.log('then');
                // })
              },
              {
                target: '.simulazione-step-6',
                content: `Questo bottone ti permette di eseguire la simulazione, 
                sempre dopo aver correttamente compilato i campi`,
                params: {
                  placement: 'top-end'
                }
              },
              {
                target: '.simulazione-step-7',
                content: `Questo bottone ti permette di tornare alla pagina precedente`,
                params: {
                  placement: 'top-start'
                }
              },
              {
                target: '.simulazione-step-8',
                content: `Se vuoi abbandonare la simulazione usa questo bottone.<br><br>
                Ricorda che il giorno del vero Click Day non potrai tornare indietro se l’invio della domanda è difficile, avrai una sola chance. Per cui ti consigliamo di non abbandonare mai le simulazioni ma di allenarti a superarle tutte!<br><br>
                Ora tocca a te, cliccando su Fine tornerai alla prima pagina e potrai svolgere questa simulazione di prova!`,
                params: {
                  placement: 'left-start'
                }
              },
            ]     
        }

        setTimeout(() => {
          this.$tours['explanatoryTour'].start();
        }, 10);
      }
    },
    vaiAllaPaginaPrecedente(currentStep) {
      this.currentStep--;
      if (this.currentStep == 4) {
        this.toggleDomande();
      }
    },
    vaiAllaPaginaSuccessiva(currentStep) {
      this.currentStep++;
      if (this.currentStep == 5) {
        this.toggleDomande();
      }
    },
    utentePuoInteragire(currentStep) {
      this.tourInEsecuzione = false;
      this.toggleDomande();
    }
  },
  computed: {
    orarioSimulazione() {
      return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('HH:mm:ss');
    },
    annoMeseGiornoSimulazione() {
      return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
    },
    isSimulazioneGuidata() {
      return this.datiSimulazione.simulazioneGuidata;
    },

    // localIdSimulazione () {
    //   return localStorage.getItem('idSimulazione');
    // },
    // localDataOraSimulazione () {
    //   return localStorage.getItem('dataOra');
    // },
  }
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap');
  
  .body {
    min-width: 489.1px;
    max-width: 1366px;
    width: auto;
    margin-right: auto;
    margin-left: auto;
    font-family: 'Open Sans', sans-serif;
    font-size: 14.4333px;
  }
  footer {
    position: absolute;
    bottom: 0;
    left: 0;
    position: absolute;
    width: 100%;
    background-color: #002e5f;
    padding: 20px 60px 20px;
    color: #fff;
    font-size: .9em;
  }
  #logo-inail {
    margin-left: 60px;
    margin-bottom: 40px;
    display: block;
    width: 176px;
    height: 56px;
  }
  #logo-inail img {
    width: 176px;
  }
  h1 {
    display: none
  }
  h2 {
    margin-top: 0;
  }
  h3 {
    margin: 0;
    margin-bottom: 30px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 16.5px;
  }
  h4 {
    font-size: 1.25em;
    margin-top: 10px;
    margin-bottom: 25px;
    font-weight: 500;
    line-height: 1.1;
  }
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }
  p {
    margin-bottom: 10px;
  }
  header {
    padding-top: 40px;
    border-bottom: 20px solid #002e5f;
  }
  .main {
    border-top: 20px solid #1E6665;
    padding: 30px;
  }
  .main h2 {
    color: #002e5f;
    margin-bottom: 30px;
    font-family: 'Open Sans semibold', sans-serif;
    font-size: 23.8333px;
    font-weight: 500;
  }
  .mr-15 {
      margin-right: 15px;
  }
  .form-gray {
    background-color: #f2f2f2;
    padding: 35px 30px;
  }
  .form-elem {

    margin-bottom: 20px;
  }
  .form-elem .msg {
    position: relative;
    top: 5px;
    display: none;
  }
  .form-elem input:not([type="checkbox"]), form-elem label input:not([type="radio"]), .form-elem select {
    width: 100%;
    border: 1px solid #afafaf;
    background-color: #fff;
    height: 34px;
    box-sizing: border-box;
    padding: 6px 12px;
  }
  .form-elem input:focus, .form-elem select:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  }
  .form-elem label {
    margin-bottom: 5px;
    display: inline-block;
  }
  .form-elem.errore .msg {
    display: block;
  }
  .form-elem.errore input:focus, .form-elem.errore select:focus {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
  }
  .form-elem.errore input, .form-elem.errore select {
    border-color: #ff5252 ;
    /* border-color: #C9291B; */
  }
  .form-elem.errore label, .testo-errore {
    color: #ff5252 ;
    /* color: #C9291B; */
  }
  .form-elem.date-elem label{
    display: block;
  }
  .form-elem.date-elem input{
      width: 200px;
  }
  .btn {
    background-color: #002e5f;
    color: #fff;
    text-transform: uppercase;
    border-radius: 0;
    border: 0;
    min-width: 160px;
    font-weight: 400;
    padding: 6px 12px;
    line-height: 1.92857em;
    cursor: pointer;
    &.abbandona {
      background-color: #bc2025;
    }
  }
  .btn-row {
    height: 40px;
    margin-top: 40px;
  }
  .btn[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
    background: #d2d2d2;
    border-color: #d2d2d2;
    color: #002e5f;
    opacity: 1 !important;
  }

  .btn:focus, input[type=checkbox]:focus, .feedback:focus {
    outline: thin dotted;
    outline-offset: -2px;
  }
  input[type=checkbox] {
    margin: 0;
    margin-right: 5px;
    top: 3px;
    position: relative;
  }
  .pull-right {
    float: right;
  }
  .xs-12 {
    width: 100%;
  }

  ::v-deep ._radio_group label,
  ::v-deep ._checkbox label {
    animation: none !important;
  }

  /*SM*/
  @media (min-width: 768px) {}
  /*MD*/
  @media (min-width: 992px) {
    .md-3 {
        width: 25%;
    }
    .md-6 {
      // width: 50%;
      width: 100%;
    }
  }

  /*LG*/
  @media (min-width: 1200px) {}
  .loader-overlay {
    position: fixed;
    background-color: #002E5F;
    background-color: rgba(0, 46, 95, 0.2);
    width:100%;
    height:100%;
    top:0;
    left: 0;
    opacity: 1;
    z-index: 500000;
  }
  .loader-overlay span{
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    border: 10px solid #106CDB; /* Light grey */
    border-top: 10px solid #002e5f; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .data-summary strong {
      width: 200px;
      display: inline-block;
  }

  .avviso-finale-prova {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-overlay {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .tour-2-3 {
    width: 100%;
  }
  @media (min-width: 992px) {
    .tour-2-3 {
      width: 50%;;
    }
  }

  .ok-button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }
  .ok-button {
    color: #002e5f;
    font-size: 20px;
    text-decoration: none;
    padding: 5px 10px;
    background-color: white;
    border-radius: 3px;
  }
</style>